<template>
    <!-- Summary cards (Count, In payment, paid, sum) -->
    <div
        v-if="invoices.length > 0"
        class="d-flex mb-3"
        style="gap: 1rem; flex-wrap: wrap;"
    >
        <div class="card p-3 stat-card">
            <div class="text-left">
                <div class="small text-muted mb-2">{{ $t('invoice_history.total_invoices') }}</div>
                <div class="h2 mb-0">{{ totals.count }}</div>
            </div>
        </div>

        <div class="card p-3 stat-card">
            <div class="text-left">
                <div class="small text-muted mb-2">{{ $t('invoice_history.in_progress') }}</div>
                <div class="h2 mb-0 text-warning">{{ totals.inProgress }}</div>
                <div class="small text-muted stat-card-sum">{{ formatCurrency(totals.inProgressSum) }}</div>
            </div>
        </div>

        <div class="card p-3 stat-card">
            <div class="text-left">
                <div class="small text-muted mb-2">{{ $t('invoice_history.paid') }}</div>
                <div class="h2 mb-0 text-success">{{ totals.paid }}</div>
                <div class="small text-muted stat-card-sum">{{ formatCurrency(totals.paidSum) }}</div>
            </div>
        </div>

        <div class="card p-3 stat-card">
            <div class="text-left">
                <div class="small text-muted mb-2">{{ $t('invoice_history.rejected') }}</div>
                <div class="h2 mb-0 text-danger">{{ totals.rejected }}</div>
                <div class="small text-muted stat-card-sum">{{ formatCurrency(totals.rejectedSum) }}</div>
            </div>
        </div>

        <div class="card p-3 stat-card">
            <div class="text-left">
                <div class="small text-muted mb-2">
                    {{ selectedStatus ? getStatusText(selectedStatus) + ' - ' + $t('common.total') : $t('invoice_history.total_sum') }}
                </div>
                <div class="h2 mb-0">{{ formatCurrency(totals.sum) }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import {invoicingHelper} from "../mixins/InvoicingMixin.js";

export default {
    name: 'InvoiceSummary',
    mixins: [invoicingHelper],
    data()  {
        return {
            totals: { count: 0, inProgress: 0, paid: 0, rejected: 0, sum: 0, inProgressSum: 0, paidSum: 0, rejectedSum: 0 },
            selectedStatus: null
        }
    },
    props: {
        invoices: {type: Array, default: []},
        status: {type: Number, detault: null}
    },
    watch: {
        invoices() {
            this.updateTotals()
        }
    },
    mounted() {
       this.updateTotals()
    },
    methods: {
        toCents(value) {
            const num = Number(value)
            return Number.isFinite(num) ? num : 0
        },
        updateTotals() {
            this.selectedStatus = this.status
            const totalsTemp = { count: 0, inProgress: 0, paid: 0, rejected: 0, sum: 0, inProgressSum: 0, paidSum: 0, rejectedSum: 0 }
            this.invoices?.forEach(i => {
                // Actual invoices
                totalsTemp.count++
                const invoiceCents = this.toCents(i.total_sum)
                if (i.status === 3) {
                    totalsTemp.paid++
                    totalsTemp.paidSum += invoiceCents
                    if (!this.status || this.status === i.status) {
                        totalsTemp.sum += Number(i.total_sum) || 0
                    }
                } else if (i.status === 2) {
                    totalsTemp.inProgress++
                    totalsTemp.inProgressSum += invoiceCents
                    if (!this.status || this.status === i.status) {
                        totalsTemp.sum += Number(i.total_sum) || 0
                    }
                } else if (i.status === 4) {
                    totalsTemp.rejected++
                    totalsTemp.rejectedSum += invoiceCents
                    // Rejected does not affect the total sum - only paid and in progress do
                    // except user filters with status = rejected
                    if (this.status === 4) {
                        totalsTemp.sum += Number(i.total_sum) || 0
                    }
                }
                // Credit notes
                if (i.credit_notes && i.credit_notes.length > 0) {
                    i.credit_notes.forEach(note => {
                        totalsTemp.count++
                        const cnSum = (note.credit_note_rows || []).reduce((acc, r) => acc + this.toCents(r.sum), 0)
                        if (note.status === 2) {
                            totalsTemp.inProgress++
                            totalsTemp.inProgressSum += cnSum
                            if (!this.status || this.status === note.status) {
                                totalsTemp.sum += cnSum
                            }
                        } else if (note.status === 3) {
                            totalsTemp.paid++
                            totalsTemp.paidSum += cnSum
                            if (!this.status || this.status === note.status) {
                                totalsTemp.sum += cnSum
                            }
                        } else if (note.status === 4) {
                            totalsTemp.rejected++
                            totalsTemp.rejectedSum += cnSum
                            if (this.status === 4) {
                                totalsTemp.sum += cnSum
                            }
                        }
                    })
                }
            })
            if (totalsTemp.sum !==  0) {
                totalsTemp.sum = totalsTemp.sum / 100
            }
            totalsTemp.inProgressSum = totalsTemp.inProgressSum / 100
            totalsTemp.paidSum = totalsTemp.paidSum / 100
            totalsTemp.rejectedSum = totalsTemp.rejectedSum / 100
            this.totals = totalsTemp
        }
    }
}

</script>

<style scoped>
.card { background: #fff; border: 1px solid #e6e6e6; border-radius: 4px; }

.stat-card {
    border-radius: 12px;
    border: 1px solid #e0e0e0;
   flex: 1 1 0;
    min-width: 200px;
}

.stat-card-sum {
    margin-top: 0.25rem;
    word-break: break-word;
}

</style>
